import { isDev } from "../developmentCheck/developmentCheck";

// Словарь названий картинок и их номеров
export enum IndorImages {
    Road = "1625",
    MessageInfo = "0135",
    Map = "0030",
    MapNavigateZoom = "0155",
    FigurePolylinePoints = "5251",
    ModePolygonSquare = "5345",
    CadastreProject = "1223",
    VideoPanoramic = "6352",
    ButtonTarget = "4801",
    MapLayers = "0368",
    Print = "0144",
    Geomarker = "0383",
    Find = "0192",
    ExcelExport = "0273",
    Table = "0427",
    InternetMail = "0257",
    TrafficPlan = "7552"
}

export enum IndorHuges {
    HelpSendQuestion = "001",
    HelpSendBugs = "002",
    HelpInternet = "004",
    HelpIndorSoftSite = "006",
    HelpOnlineHelp = "007",
}

type IndorImagesCatalog = "IndorImages" | "IndorHuges"

export function getIndorImageSrc(index: string, size = 40, catalog: IndorImagesCatalog = "IndorImages" ) {
    if (isDev()) {
        try {
            return require(`../../assets/images/${catalog}/${index}-${size}x${size}.png`)
        } catch {
            console.error(`Ошибка загрузки изображения IndorImage-${index}`)
        }
    } else {
        return `/assets/images/${catalog}/${index}-${size}x${size}.png`
    }
}
